var _defs, _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgCodeSwitcher(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_2",
    "data-name": "Layer 2",
    xmlns: "http://www.w3.org/2000/svg",
    width: 152.38129,
    height: 152.38129,
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    viewBox: "0 0 152.38129 152.38129",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient",
    x1: -1576.87598,
    y1: 5527.87733,
    x2: -1543.54257,
    y2: 5527.87733,
    gradientTransform: "translate(5661.17762 -1476.82338) rotate(-90) scale(1 -1)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#000",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7,
    stopColor: "#000"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-2",
    x1: -1576.87608,
    y1: 7033.20868,
    x2: -1543.54267,
    y2: 7033.20868,
    gradientTransform: "translate(-7014.1896 -1476.82347) rotate(-90)",
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("mask", {
    id: "mask",
    x: -0.02857,
    y: 0,
    width: 152.40987,
    height: 152.38129,
    maskUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("g", {
    id: "gqmmhtww8c"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M128.52409,90.5621v28.5334h-9.52383v9.52383h9.52383c5.2524,0,9.52383-4.27144,9.52383-9.52383v-28.5334c0-5.2524,4.27144-9.52383,9.52383-9.52383v-9.52383c-10.50478,0-19.04766,8.54288-19.04766,19.04766Z",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M114.25264,100.0526v-33.33341h38.09532v33.33341h-38.09532Z",
    fill: "url(#linear-gradient)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M138.05268,61.91919v-28.5334c0-5.34287-4.18572-9.52383-9.52383-9.52383h-9.52383v9.52383h9.52383v28.5334c0,10.50479,8.54288,19.04766,19.04766,19.04766v-9.52383c-5.2524,0-9.52383-4.27144-9.52383-9.52383Z",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M23.76672,119.10026v-28.5334c0-10.50478-8.54288-19.04766-19.04766-19.04766v9.52383c5.25239,0,9.52383,4.27144,9.52383,9.52383v28.5334c0,5.2524,4.27144,9.52383,9.52383,9.52383h9.52383v-9.52383h-9.52383Z",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M-.02857,100.0526v-33.33341h38.09532v33.33341H-.02857Z",
    fill: "url(#linear-gradient-2)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M33.29055,33.38579v-9.52383h-9.52383c-5.25239,0-9.52383,4.27144-9.52383,9.52383v28.5334c0,5.25239-4.27144,9.52383-9.52383,9.52383v9.52383c10.50479,0,19.04766-8.54287,19.04766-19.04766v-28.5334h9.52383Z",
    fill: "#fff"
  })))), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-3",
    x1: 0,
    y1: 76.19065,
    x2: 152.38129,
    y2: 76.19065,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#8100e0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.09285,
    stopColor: "#6b12e5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.26122,
    stopColor: "#4a2fee"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.43437,
    stopColor: "#3045f5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.61198,
    stopColor: "#1d55fa"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.79671,
    stopColor: "#125efd"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#0f62fe"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-4",
    x1: 42.79057,
    y1: 76.19303,
    x2: 109.45263,
    y2: 76.19303,
    xlinkHref: "#linear-gradient-3"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Layer_1-2",
    "data-name": "Layer 1"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0,0h152.38129v152.38129H0V0Z",
    fill: "url(#linear-gradient-3)"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M66.59538,47.64772h42.85724v9.52383h-42.85724v-9.52383ZM42.79057,47.64772h14.28575v9.52383h-14.28575v-9.52383ZM42.79057,71.45254h14.28575v9.52384h-14.28575v-9.52384ZM42.79057,95.2145h14.28575v9.52383h-14.28575v-9.52383ZM66.5811,95.2145h42.85724v9.52383h-42.85724v-9.52383ZM66.5811,71.45254h42.85724v9.52384h-42.85724v-9.52384Z",
    fill: "url(#linear-gradient-4)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCodeSwitcher);
export default __webpack_public_path__ + "static/media/code_switcher.ccc044dc49eee6654cc825216bcca4c3.svg";
export { ForwardRef as ReactComponent };